import {ShapeInterface} from "./interface/shapeInterface";
import {DrawingConfigurationInterface} from "./interface/drawingConfigurationInterface";
import {IntSashInterface} from "./interface/intSashInterface";
import {MullionInterface} from "./interface/mullionInterface";
import {SashInterface} from "./interface/sashInterface";
import {MuntinInterface} from "./interface/muntinInterface";
import {ProfileInterface} from "./interface/profileInterface";

export class ConfigurationObjectService
{
    getBaseConfiguration(): DrawingConfigurationInterface
    {
        return {
            $version: 5,
            height: 0,
            width: 0,
            sideAccessories: {},
            shape: {
                h1: 0,
                h2: 0,
                h3: 0,
                s1: 0,
                s2: 0,
                s3: 0,
                d: 0,
                shape: 'rect',
                type: null,
            },
            frame: {},
            colors: {
                frame: {
                    inner: {
                        color: 'ffffff',
                        id: 1,
                    },
                    outer: {
                        color: 'ffffff',
                        id: 1,
                    }
                },
                sash: {
                    inner: {
                        color: 'ffffff',
                        id: 1,
                    },
                    outer: {
                        color: 'ffffff',
                        id: 1,
                    }
                }
            },
            mullions: [],
            sashes: [],
            muntins: {
                colorOuter: {
                    color: 'ffffff'
                },
                colorInner: {
                    color: 'ffffff'
                },
                size: 0
            },
            usedProfiles: this.getProfiles(),
            timestamp: 0,
        };
    }

    getShape(): ShapeInterface
    {
        return {
            h1: 0,
            h2: 0,
            h3: 0,
            s1: 0,
            s2: 0,
            s3: 0,
            d: 0,
            shape: 'rect',
            type: null,
        };
    }

    getSash(): SashInterface
    {
        return {
            id: null,
            type: {
                handlePosition: null,
                type: null
            },
            filling: {id: 0},
            intSashes: [],
            width: 0,
            height: 0,
            x: 0,
            y: 0,
            muntins: [],
            intMullions: [],
            nearMullions: {
                bottom: -1,
                left: -1,
                right: -1,
                top: -1,
            }
        }
    }

    getIntSash() : IntSashInterface
    {
        return {
            id: null,
            parentId: null,
            width: 0,
            height: 0,
            x: 0,
            y: 0,
            filling: {id: 0, type: ''},
            muntins: [],
            nearMullions: {
                bottom: -1,
                left: -1,
                right: -1,
                top: -1
            }
        };
    }

    getMullion(): MullionInterface
    {
       return {
           id: null,
           profileId: null,
           direction: null,
           adjacentSashes: {
               bottom: [],
               top: [],
               left: [],
               right: []
           },
           length: null,
           position: null,
           perpendicularMullions: {
               bottom: [],
               top: [],
               left: [],
               right: []
           }
       };
    }

    getMuntin(): MuntinInterface
    {
        return {
            id: 1,
            start: {
                x: 0,
                y: 0,
            },
            end: {
                x: 0,
                y: 0
            }
        };
    }

    getProfiles(): Array<ProfileInterface>
    {
        return [
            {
                type: 'frame',
                id: 1,
                rebateWidth: 20,
                rebateWidthOut: 0,
                spaceGlass: 50,
                spaceSash: 38,
                width: 46,
                widthOut: 67
            },
            {
                type: 'sash',
                id: 2,
                rebateWidth: 20,
                rebateWidthOut: 0,
                spaceGlass: 58,
                spaceSash: 0,
                width: 57,
                widthOut: 78
            },
            {
                type: 'divider',
                id: 3,
                rebateWidth: 20,
                rebateWidthOut: 0,
                spaceGlass: 25,
                spaceSash: 13,
                width: 42,
                widthOut: 84
            },
            {
                type: 'threshold',
                id: 4,
                rebateWidth: 20,
                rebateWidthOut: 0,
                spaceGlass: 0,
                spaceSash: 0,
                width: 0,
                widthOut: 0
            },
            {
                type: 'divider',
                id: 5,
                rebateWidth: 20,
                rebateWidthOut: 0,
                spaceGlass: 25,
                spaceSash: 0,
                width: 42,
                widthOut: 84
            }
        ];
    }
}
